import identity from 'transmute/identity';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import { REUPLOAD_DOCUMENT_CHIRP_CREATE_SUCCEEDED, REUPLOAD_DOCUMENT_CHIRP_CREATE_FAILED, REUPLOAD_PROGRESS_PERCENT_CHIRP } from 'documents-lib/js/constants/ActionTypes';
import { uploadFileCHIRP } from 'documents-ui/api/UploadChirpApi';
import * as DocumentsApi from 'documents-ui/api/DocumentsApi';
const reuploadDocumentChirpSuccess = createAction(REUPLOAD_DOCUMENT_CHIRP_CREATE_SUCCEEDED, identity);
const reuploadDocumentChirpFailed = createAction(REUPLOAD_DOCUMENT_CHIRP_CREATE_FAILED, identity);
const reuploadProgressPercentChirp = createAction(REUPLOAD_PROGRESS_PERCENT_CHIRP, identity);
export default (({
  documentId,
  fileName,
  file,
  onPercentProgress
}) => async dispatch => {
  const handleUploadProgress = percent => {
    if (onPercentProgress) {
      onPercentProgress(percent);
    }
    dispatch(reuploadProgressPercentChirp({
      id: documentId,
      percent
    }));
  };
  try {
    await uploadFileCHIRP({
      file,
      onProgress: handleUploadProgress,
      documentId
    });
    const documentData = await DocumentsApi.fetchDocumentCHIRP(documentId);
    addAlert('reuploadFile', 'success', {
      name: fileName
    });
    dispatch(reuploadDocumentChirpSuccess({
      documentId
    }));
    return documentData;
  } catch (_e) {
    addAlert('reuploadFile', 'danger', {
      name: fileName
    });
    dispatch(reuploadDocumentChirpFailed(documentId));
    return null;
  }
});